module.exports = __webpack_public_path__ + "img/speaker_6.347669a9.jpg";